import type { QueryClient, QueryObserverOptions } from '@tanstack/query-core';
import type { Suggestion, SuggestionsService } from 'src/services/SuggestionsService';

const SUGGESTIONS_QUERY_KEY = 'suggestions';

export type LocalSuggestions = {
    recentlyAccessed: Suggestion[];
    recentlyCreated: Suggestion[];
};

export const getSuggestionsForKeyQuery = (
    suggestions: SuggestionsService,
    filters: { types?: Suggestion['type'][]; limit?: number },
): QueryObserverOptions<LocalSuggestions> => ({
    queryKey: [SUGGESTIONS_QUERY_KEY, filters],
    queryFn: () => {
        return {
            recentlyAccessed: suggestions.getItems({ ...filters, query: 'accessedAt' }),
            recentlyCreated: suggestions.getItems({ ...filters, query: 'createdAt' }),
        };
    },
});

export const invalidateSuggestionsForKey = (queryClient: QueryClient) => {
    queryClient.invalidateQueries({
        queryKey: [SUGGESTIONS_QUERY_KEY],
        refetchType: 'active',
    });
};
